export default __webpack_public_path__ + "static/media/Ativo 2.ddc76ba0.png";